import React, { useContext } from 'react';
import { ChatbotContext } from '../../Context/ChatbotContext';
import { ChatbotStateContext } from '../../Context/ChatbotStateContext';
import ImgWelcome from '../../assets/chatbot/img_Welcome.svg';
import { IoMdCloseCircle } from 'react-icons/io';
import ReCAPTCHA from 'react-google-recaptcha';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import logoblanco from '../../assets/chatbot/Logo_B2.svg';

const SignIn = () => {
  // 6Ld-SagqAAAAAEdBk_qPMXwhrjMsU9OxfxKeVF2H   Local 
  // 6LcCYdMqAAAAADKfg6bwolMw1I6qGBPSqD3Qz63Z
  const { isChatOpen, toggleChat } = useContext(ChatbotContext);
  const {
    userData,
    setUserData,
    formErrors,
    setFormErrors,
    captchaVerified,
    setCaptchaVerified,
    isSubmitted,
    setCurrentStep,
    userId,
    sessionId,
    handleRegisterSubmit,
  } = useContext(ChatbotStateContext);

  const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
  const phoneRegex = /^\+?[1-9]\d{6,14}$/;

  const handlePhoneChange = (value) => {
    const cleanedValue = value.replace(/\s+/g, '').replace(/[^\d+]/g, '');
    setUserData({ ...userData, phone: cleanedValue });

    if (!phoneRegex.test(cleanedValue)) {
      setFormErrors((prev) => ({ ...prev, phone: "El teléfono debe ser válido y con formato internacional." }));
    } else {
      setFormErrors((prev) => ({ ...prev, phone: "" }));
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!userData.fullName.trim()) {
      errors.fullName = "El nombre completo es obligatorio.";
    }
    if (!userData.email.trim()) {
      errors.email = "El correo electrónico es obligatorio.";
    } else if (!emailRegex.test(userData.email)) {
      errors.email = "El formato del correo electrónico no es válido.";
    }
    if (!userData.phone.trim()) {
      errors.phone = "El teléfono es obligatorio.";
    } else if (!phoneRegex.test(userData.phone)) {
      errors.phone = "El teléfono debe ser válido y con formato internacional.";
    }
    if (!userData.company.trim()) {
      errors.company = "El campo Empresa es obligatorio.";
    }

    if (!captchaVerified) {
      errors.recaptcha = "Por favor, verifica que no eres un robot.";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0; // Retorna true si no hay errores
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    handleRegisterSubmit(); // Ya no pasa `e`, solo ejecuta la función
  };



  return (
    <div
      id="chatbot-container"
      className={`chatbot-container ${isChatOpen ? 'chatbot-expanded' : ''}`}
    >
      <div
        id="chatbot-toggle"
        className={`chatbot-header ${isChatOpen ? 'chatbot-header-open' : 'chatbot-header-collapsed'} ${isChatOpen && 'chatbot-header-large'}`}
        onClick={() => {
          if (!isChatOpen) {
            if (!userId || !sessionId) {
              setCurrentStep('welcome');
            }
          }
          toggleChat();
        }}
      >
        {!isChatOpen && (
          <div className="chatbot-closed-icon flex justify-center items-center">
            <img src={logoblanco} alt="Logo Blanco" className="h-12 w-12" />
          </div>
        )}

        {isChatOpen && (
          <div className="flex items-center justify-center w-full">
            <img src={ImgWelcome} alt="Bot Icon" className="max-w-[25%] mb:max-w-[60%] mb:h-[27vh]" />
            <IoMdCloseCircle className="btn-close" onClick={toggleChat} />
          </div>
        )}
      </div>

      {isChatOpen && (
        <div id="registration-window" className="chatbot-forms bg-secondary">
          <div className="forms-container space-y-4 bg-white">
            <div className="forms">
              <h2 className="forms-text">¡Crea un nuevo chat!</h2>

              <form onSubmit={handleSubmit} className="space-y-3 mb:space-y-4">
                <div>
                  <input
                    type="text"
                    name="fullName"
                    placeholder="Nombre y apellido"
                    value={userData.fullName}
                    onChange={(e) => setUserData({ ...userData, fullName: e.target.value })}
                    className={`forms-input placeholder:text-xs ${formErrors.fullName ? 'border-red-500' : ''}`}
                  />
                  {formErrors.fullName && <p className="error-text">{formErrors.fullName}</p>}
                </div>
                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={userData.email}
                    onChange={(e) => setUserData({ ...userData, email: e.target.value })}
                    className={`forms-input placeholder:text-xs ${formErrors.email ? 'border-red-500' : ''}`}
                  />
                  {formErrors.email && <p className="error-text">{formErrors.email}</p>}
                </div>
                <div>
                  <PhoneInput
                    country={'co'}
                    value={userData.phone}
                    onChange={handlePhoneChange}
                    disabled={isSubmitted}
                    inputStyle={{ width: "100%", height: "2.5rem", fontSize: "16px", borderRadius: "0.2rem", border: "none", backgroundColor: "#ECEDFF" }}
                    buttonStyle={{ backgroundColor: "#ECEDFF", borderRadius: "0.2rem", border: "none" }}
                  />
                  {formErrors.phone && <p className="error-text">{formErrors.phone}</p>}
                </div>
                <div>
                  <input
                    type="text"
                    name="company"
                    placeholder="Empresa"
                    value={userData.company}
                    onChange={(e) => setUserData({ ...userData, company: e.target.value })}
                    className={`forms-input placeholder:text-xs ${formErrors.company ? 'border-red-500' : ''}`}
                  />
                  {formErrors.company && <p className="error-text">{formErrors.company}</p>}
                </div>

                <div>
                  <ReCAPTCHA
                    sitekey="6LctO7ksAAAAAKNiiLfTCZPvMqwIWV3h8NBXefrI"
                    onChange={(value) => setCaptchaVerified(!!value)}
                  />
                  {formErrors.recaptcha && <p className="error-text">{formErrors.recaptcha}</p>}
                </div>
                <button
                  className={`btn-chat ${isSubmitted ? 'btn-disabled' : ''}`}
                  type="submit"
                  id="button"
                  disabled={isSubmitted}
                >
                  {isSubmitted ? (
                    <div className="loading-spinner"></div>
                  ) : (
                    'Comenzar'
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignIn;
